<button class="pay-button pay-hidden apple-pay-button"></button>
<button class="pay-button pay-hidden google-pay-button"></button>
<div id="i4goFrame">
</div>